<script lang="ts">
    interface Props {
        src: string | undefined;
        alt: string;
        fallback: string;
        classes: string;
    }

    let { src, alt, fallback, classes }: Props = $props();

    let errored = $state(false);
    let currentSrc = $derived(errored ? fallback : (src ?? fallback));
</script>

<img class={classes} src={currentSrc} {alt} onerror={() => (errored = true)} draggable="false" />
